import { handleActions } from "redux-actions";
import {
    setInventoryForms,
    deleteInventoryFormSuccess,
    setInventoryForm, addInventory,
    setInventoryFormsCount,
    setPagingInventory,
    setInventoryFilters,
} from "../action";

const initialState = {
    items: [],
    count: 0,
    errors: null,
    form: {},
    formsById: {},
    loading: false,
    loadingById: {},
    saving: false,
    savingById: {},
    filters: {
        point: null,
    },
    paging: {
        start: 0,
        limit: 10,
    },
};

const inventoryForms = handleActions(
    {
        [setInventoryForms]: (state, { payload }) => ({
            ...state,
            items: payload,
        }),
        [setInventoryFormsCount]: (state, { payload }) => ({
            ...state,
            count: payload,
        }),
        [setInventoryForm]: (state, { payload }) => ({
            ...state,
            form: payload,
            formsById: {
                ...state.formsById,
                [payload.id]: payload,
            },
        }),
        [addInventory]: (state, { payload }) => {
            const updatedItems = state.items.map(item => {
                if (
                    item.point && payload.point && item.point.id === payload.point.id &&
                    new Date(item.date) < new Date(payload.date) &&
                    item.status === true
                ) {
                    return { ...item, status: false };
                }
                return item;
            });
            return {
                ...state,
                items: [payload, ...updatedItems],
            };
        },
        [deleteInventoryFormSuccess]: (state, { payload: id }) => ({
            ...state,
            items: state.items.filter(item => item.id !== id),
        }),
        [setPagingInventory]: (state, { payload }) => {
            const { start, limit } = payload;
            return ({
                ...state,
                paging: {
                    start: +start || 0,
                    limit: +limit || 10,
                }
            })
        },
        [setInventoryFilters]: (state, { payload }) => {
            return ({
                ...state,
                filters: payload,
            })
        },
        'SET LOADER': (state, action) => {
            if (action.field === 'inventoryForms') {
                return { ...state, loading: action.value };
            }
            if (action.field === 'inventoryForm') {
                return {
                    ...state,
                    loadingById: {
                        ...state.loadingById,
                        [action.id]: action.value
                    }
                };
            }
            return state;
        },
        'SET SAVING': (state, action) => {
            if (action.field === 'inventoryForm') {
                return {
                    ...state,
                    savingById: {
                        ...state.savingById,
                        [action.id]: action.value
                    }
                };
            }
            return state;
        },
        'REMOVE_INVENTORY_FORM': (state, { payload: id }) => ({
            ...state,
            formsById: Object.keys(state.formsById).reduce((acc, key) => {
                if (parseInt(key, 10) !== id) {
                    acc[key] = state.formsById[key];
                }
                return acc;
            }, {}),
            items: state.items.filter(item => item.id !== id)
        }),
    },
    initialState
);

export default inventoryForms;
